import React, {Component} from 'react'
import {Button, Menu, Icon, Label, Table} from 'semantic-ui-react'
import { NavLink } from 'react-router-dom'
import {reactLocalStorage} from 'reactjs-localstorage';
import {Document, Page, PDFDownloadLink,View,Text} from "@react-pdf/renderer";
export default class MenuExampleSizeSmall extends Component {
    state = { activeItem: '' }

    handleItemClick = (e, { name }) => this.setState({ activeItem: name })

    render() {
        const { activeItem } = this.state
        const {search_bar} = this.state
        const removeToken = () =>{
            reactLocalStorage.clear();
            window.open('/login','_self');
        }


        return (
            <Menu size='huge'  fixed='top' style={{paddingLeft:'30px'}}>
                <Menu.Item
                    name='Home'
                    active={activeItem === 'home'}
                    as={NavLink}
                    to='/home'
                    onClick={this.handleItemClick}
                />
                {
                    reactLocalStorage.get('username') == 'admin' ?
                        <>
                            <Menu.Item
                                name='export-admission'
                                active={activeItem === 'export-admission'}
                                as={NavLink}
                                to='/export-admission'
                                onClick={this.handleItemClick}
                            />
                            {/*<Menu.Item*/}
                            {/*    name='export-discharge'*/}
                            {/*    active={activeItem === 'export-discharge'}*/}
                            {/*    as={NavLink}*/}
                            {/*    to='/export-discharge'*/}
                            {/*    onClick={this.handleItemClick}*/}
                            {/*/>*/}
                            <Menu.Item
                                name='export-opnote'
                                active={activeItem === 'export-opnote'}
                                as={NavLink}
                                to='/export-opnote'
                                onClick={this.handleItemClick}
                            />
                            <Menu.Item
                                name='users'
                                active={activeItem === 'users'}
                                as={NavLink}
                                to='/users'
                                onClick={this.handleItemClick}
                            >
                                User Management
                            </Menu.Item>
                            <Menu.Item
                                name='staff'
                                active={activeItem === 'staff'}
                                as={NavLink}
                                to='/staff'
                                onClick={this.handleItemClick}
                            >
                                Staff Configuration
                            </Menu.Item>
                        </>
                        : ''
                }

                {/*<Menu.Item*/}
                {/*    name='patient'*/}
                {/*    active={activeItem === 'patient'}*/}
                {/*    as={NavLink}*/}
                {/*    to='/patients'*/}
                {/*    onClick={this.handleItemClick}*/}
                {/*>*/}
                {/*    ลงทะเบียนผู้ป่วย*/}

                {/*</Menu.Item>*/}
                {/*<Menu.Item*/}
                {/*    name='visit'*/}
                {/*    active={activeItem === 'visit'}*/}
                {/*    as={NavLink}*/}
                {/*    to='/visit'*/}
                {/*    onClick={this.handleItemClick}*/}
                {/*>*/}
                {/*    ลงทะเบียนใช้บริการ*/}

                {/*</Menu.Item>*/}


                {/*<Menu.Item*/}
                {/*    name='admission'*/}
                {/*    active={activeItem === 'admission'}*/}
                {/*    as={NavLink}*/}
                {/*    to='/admission'*/}
                {/*    onClick={this.handleItemClick}*/}
                {/*/>*/}






                <Menu.Menu position='right'>



                    <Menu.Item>
                        <Button as='div' labelPosition='right'>
                            <Button icon>
                                <Icon name='user circle outline' />

                            </Button>
                            <Label as='a' basic pointing='left'>
                                {reactLocalStorage.get('name')}
                            </Label>
                        </Button>
                        &nbsp; &nbsp;
                        <Button as='a'  style={{ marginLeft: '0.5em',height:38,lineHeight:0.5 }} onClick={(e)=>removeToken()}>
                           Logout
                        </Button>
                    </Menu.Item>
                </Menu.Menu>
            </Menu>
        )
    }
}
